import Vue from 'vue'
import Router from 'vue-router'
import { HUINavbarButtonGo } from '@/halifax-ui'
import NavbarCartButton from '@/containers/NavbarCartButton'
import routes from '@/router/routes'
import animateProperty from '@/utils/animateProperty'

const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home')
const Booking = () => import(/* webpackChunkName: "booking" */ '@/views/Booking')
const Booking1 = () => import(/* webpackChunkName: "booking" */ '@/views/Booking1')
const Booking2 = () => import(/* webpackChunkName: "booking" */ '@/views/Booking2')
const Booking3 = () => import(/* webpackChunkName: "booking" */ '@/views/Booking3')
const BookingPreorderIntro = () =>
  import(/* webpackChunkName: "booking" */ '@/views/BookingPreorderIntro')
const BookingPreorderMenu = () =>
  import(/* webpackChunkName: "booking" */ '@/views/BookingPreorderMenu')
const BookingPreorderCart = () =>
  import(/* webpackChunkName: "booking" */ '@/views/BookingPreorderCart')
const BookingCancel = () => import(/* webpackChunkName: "booking" */ '@/views/BookingCancel')
const Restaurants = () => import(/* webpackChunkName: "restaurants" */ '@/views/Restaurants')
const RestaurantsOverview = () =>
  import(/* webpackChunkName: "restaurants" */ '@/views/RestaurantsOverview')
const RestaurantsSingleWrapper = () =>
  import(/* webpackChunkName: "restaurants" */ '@/views/RestaurantsSingleWrapper')
const RestaurantsSingle = () =>
  import(/* webpackChunkName: "restaurants" */ '@/views/RestaurantsSingle')
const PaymentCallback = () => import(/* webpackChunkName: "checkout" */ '@/views/PaymentCallback')
const Table = () => import(/* webpackChunkName: "table" */ '@/views/Table')
const TableIntro = () => import(/* webpackChunkName: "table" */ '@/views/TableIntro')
const TableMenu = () => import(/* webpackChunkName: "table" */ '@/views/TableMenu')
const TableCart = () => import(/* webpackChunkName: "table" */ '@/views/TableCart')
const TableReceipt = () => import(/* webpackChunkName: "table" */ '@/views/TableReceipt')
// const Takeaway = () => import(/* webpackChunkName: "takeaway" */ '@/views/Takeaway')

export function createRouter() {
  Vue.use(Router)

  let router
  let popstateFired

  // Make sure we bind popstate before instantiating the router, so we ensure that this event
  // handler fires before router.beforeEach
  window.addEventListener('popstate', () => {
    popstateFired = true
  })

  // Disable native handling of scroll restoration, since our transitions are custom
  window.history.scrollRestoration = 'manual'

  router = new Router({
    mode: 'history',

    async scrollBehavior(to, from, savedPosition) {
      const scrollingElement = window.document.scrollingElement || window.document.documentElement
      const promise = router.app.$store.state.routing.transition_promise || Promise.resolve()

      if (savedPosition) {
        try {
          await promise

          return new Promise(resolve => {
            setTimeout(() => {
              animateProperty(scrollingElement, 'scrollTop', savedPosition.y, () => {
                resolve({ x: 0, y: savedPosition.y })
              })
            }, 150)
          })
        } catch (e) {
          return {
            x: 0,
            y: 0
          }
        }
      } else {
        await promise

        return {
          x: 0,
          y: 0
        }
      }
    },

    routes: [
      {
        path: '/',
        component: Home,
        name: routes.HOME,
        meta: {
          leftNavbarComponent: null,
          rightNavbarComponent: HUINavbarButtonGo,
          rightNavbarComponentAction: () =>
            router.app.$store.dispatch('SHOW_TABLE_PROMPT', { router })
        }
      },
      {
        path: '/restauranter',
        component: Restaurants,
        children: [
          {
            path: '',
            component: RestaurantsOverview,
            name: routes.RESTAURANTS,
            meta: {
              rightNavbarComponent: HUINavbarButtonGo,
              rightNavbarComponentAction: () =>
                router.app.$store.dispatch('SHOW_TABLE_PROMPT', { router })
            }
          },
          {
            path: ':restaurantSlug',
            component: RestaurantsSingleWrapper,
            children: [
              {
                path: '',
                component: RestaurantsSingle,
                name: routes.RESTAURANT,
                meta: {
                  navbarLogoHidden: true,
                  rightNavbarComponent: HUINavbarButtonGo,
                  rightNavbarComponentAction: () =>
                    router.app.$store.dispatch('SHOW_TABLE_PROMPT', { router })
                }
              }
            ]
          }
        ]
      },
      {
        path: '/booking',
        component: Booking,
        children: [
          {
            path: '',
            component: Booking1,
            name: routes.BOOKING,
            meta: {
              leftNavbarComponent: null,
              rightNavbarComponent: HUINavbarButtonGo,
              rightNavbarComponentAction: () =>
                router.app.$store.dispatch('SHOW_TABLE_PROMPT', { router })
            }
          },
          {
            path: 'dine-oplysninger',
            component: Booking2,
            name: routes.BOOKING_2
          },
          {
            path: 'kvittering/:bookingToken',
            component: Booking3,
            name: routes.BOOKING_3,
            meta: {
              customTracking: {
                path: '/booking/kvittering',
                params: ['bookingToken']
              }
            }
          },
          // {
          //   path: ':bookingToken',
          //   component: BookingPreorderIntro,
          //   name: routes.BOOKING_PREORDER_INTRO,
          //   meta: {
          //     customTracking: {
          //       path: '/booking/intro',
          //       params: ['bookingToken']
          //     }
          //   }
          // },
          // {
          //   path: ':bookingToken/menu',
          //   component: BookingPreorderMenu,
          //   name: routes.BOOKING_PREORDER_MENU,
          //   meta: {
          //     rightNavbarComponent: NavbarCartButton,
          //     rightNavbarComponentAction: route =>
          //       router.push({
          //         name: routes.BOOKING_PREORDER_CART,
          //         params: route.params.bookingToken
          //       }),
          //     customTracking: {
          //       path: '/booking/menu',
          //       params: ['bookingToken']
          //     }
          //   }
          // },
          // {
          //   path: ':bookingToken/kurv',
          //   component: BookingPreorderCart,
          //   name: routes.BOOKING_PREORDER_CART,
          //   meta: {
          //     rightNavbarComponent: NavbarCartButton,
          //     rightNavbarComponentAction: route =>
          //       router.push({
          //         name: routes.BOOKING_PREORDER_CART,
          //         params: route.params.bookingToken
          //       }),
          //     customTracking: {
          //       path: '/booking/kurv',
          //       params: ['bookingToken']
          //     }
          //   }
          // },
          {
            path: ':bookingToken/afbestil',
            component: BookingCancel,
            name: routes.CANCEL_BOOKING,
            meta: {
              customTracking: {
                path: '/booking/afbestil',
                params: ['bookingToken']
              }
            }
          }
        ]
      }
      // {
      //   path: '/bord',
      //   component: Table,
      //   children: [
      //     {
      //       path: ':orderToken',
      //       component: TableIntro,
      //       name: routes.TABLE_INTRO,
      //       meta: {
      //         rightNavbarComponent: NavbarCartButton,
      //         rightNavbarComponentAction: route =>
      //           router.push({
      //             name: routes.TABLE_CART,
      //             params: route.params.orderToken
      //           }),
      //         customTracking: {
      //           path: '/bord/intro',
      //           params: ['orderToken']
      //         }
      //       }
      //     },
      //     {
      //       path: ':orderToken/menu',
      //       component: TableMenu,
      //       name: routes.TABLE_MENU,
      //       meta: {
      //         rightNavbarComponent: NavbarCartButton,
      //         rightNavbarComponentAction: route =>
      //           router.push({
      //             name: routes.TABLE_CART,
      //             params: route.params.orderToken
      //           }),
      //         customTracking: {
      //           path: '/bord/menu',
      //           params: ['orderToken']
      //         }
      //       }
      //     },
      //     {
      //       path: ':orderToken/kurv',
      //       component: TableCart,
      //       name: routes.TABLE_CART,
      //       meta: {
      //         rightNavbarComponent: NavbarCartButton,
      //         rightNavbarComponentAction: route =>
      //           router.push({
      //             name: routes.TABLE_CART,
      //             params: route.params.orderToken
      //           }),
      //         customTracking: {
      //           path: '/bord/kurv',
      //           params: ['orderToken']
      //         }
      //       }
      //     },
      //     {
      //       path: ':orderToken/kvittering',
      //       component: TableReceipt,
      //       name: routes.TABLE_RECEIPT,
      //       meta: {
      //         customTracking: {
      //           path: '/bord/kvittering',
      //           params: ['orderToken']
      //         }
      //       }
      //     }
      //   ]
      // },
      // {
      //   path: '/payment-callback/:orderToken/:price/:status',
      //   component: PaymentCallback,
      //   name: routes.PAYMENT_CALLBACK,
      //   props: route => {
      //     return {
      //       status: route.params.status
      //     }
      //   },
      //   meta: {
      //     customTracking: {
      //       path: '/betalings-callback',
      //       params: ['orderToken', 'price', 'status']
      //     }
      //   }
      // }
    ]
  })

  const tabbarRoutes = [routes.HOME, routes.BOOKING, routes.TAKEAWAY]

  router.beforeEach((to, from, next) => {
    const $store = router.app.$store
    let activeTabbarRoute = $store.state.routing.active_tabbar_route

    // Close any open dialogs
    if ($store.state.dialog.visible) {
      $store.dispatch('dialog/HIDE')
    }

    // Compute first active menu route
    if (!activeTabbarRoute) {
      const tabbarRouteOfMatched = to.matched.find(route => tabbarRoutes.includes(route.name))
      const tabbarRoute = tabbarRouteOfMatched ? tabbarRouteOfMatched.name : routes.HOME
      activeTabbarRoute = tabbarRoute
      $store.dispatch('routing/SET_ACTIVE_TABBAR_ROUTE', tabbarRoute)
    }

    const newRouteIsTabbarRoute = tabbarRoutes.includes(to.name)
    const oldRouteIsTabbarRoute = tabbarRoutes.includes(from.name)

    if (to.name === activeTabbarRoute && !oldRouteIsTabbarRoute) {
      $store.dispatch('routing/SET_ROOT_TRANSITION', false)
      $store.dispatch('routing/SET_NAVIGATION_DIRECTION', -1)
    } else if (newRouteIsTabbarRoute) {
      $store.dispatch('routing/SET_ROOT_TRANSITION', true)
      $store.dispatch('routing/SET_NAVIGATION_DIRECTION', 1)
    } else {
      $store.dispatch('routing/SET_ROOT_TRANSITION', false)
      $store.dispatch('routing/SET_NAVIGATION_DIRECTION', 1)
    }

    if (newRouteIsTabbarRoute) {
      $store.dispatch('routing/SET_ACTIVE_TABBAR_ROUTE', to.name)
    }

    if (popstateFired) {
      $store.dispatch('routing/SET_NAVIGATION_DIRECTION', -1)
      popstateFired = null
    }

    // Announce that we're navigating, so we can show the progress bar
    if ($store.state.offline === false) {
      $store.dispatch('routing/SET_NAVIGATING', true)
    }

    next()
  })

  router.beforeResolve((to, from, next) => {
    // Beforeresolve fires when the chunk for the given route has loaded, so
    // reset navigating so we can hide the progress bar
    router.app.$store.dispatch('routing/SET_NAVIGATING', false)
    next()
  })

  return router
}
